import { Column, Row, Skeleton, SkeletonBox } from "@hightouch/htui";

import { MediaDetailHeaderControls } from "src/components/media-detail/media-detail-header-controls";

/** Stands in for `MediaDetailHeader` while loading; the controls stay usable. */
export function MediaDetailHeaderSkeleton() {
  return (
    <Column gap={2} minW={0}>
      <Row align="center" justify="space-between" gap={4} minW={0}>
        <Skeleton isLoading>
          <SkeletonBox height="24px" width="240px" borderRadius="sm" />
        </Skeleton>
        <MediaDetailHeaderControls />
      </Row>
      <Skeleton isLoading>
        <Column gap={2}>
          <SkeletonBox height="16px" width="160px" borderRadius="sm" />
          <SkeletonBox height="20px" width="200px" borderRadius="sm" />
        </Column>
      </Skeleton>
    </Column>
  );
}
